import { render } from "./Instruction.vue?vue&type=template&id=24c53930&bindings={}"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"
script.render = render

export default script